<div >
  <div >
    <div style="margin-top:1%; margin-bottom:-5px; margin-left:10px">
      <h6>
        <span style="padding-right:5px"></span>
        <i class="fa fa-bus"></i>
        <b>Vehicle </b> <span style="color:lightgray">* Please add all vehicles linked to this application</span>
      </h6>
    </div>
  </div>
  <hr>
  <div class="col-md-12">
    <div >
      <div class="col-md-12">
        <!-- <ngx-loading [show]="gridload"></ngx-loading> -->
        <table class="table table-sm table-bordered table-hover">
          <thead>
            <tr>
              <th>#</th>
                <th style="min-width:150px;">Start Date</th>
                <th>Type</th>
                <th>Registration No.</th>
                <th>No. of Seats</th>
                <th>GVM</th>
                <th>VIN</th>
                <th style="min-width:150px;">License or Roadworthy or C.O.F Expiry Date</th>
                <th style="min-width:150px;">Date From</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listvehicles, let i=index">
              <th scope="row">{{i+1}}</th>
              <td>
                <span *ngIf="item.editMode==false">{{ctrlData.permit.date_11 | date:'yyyy/MM/dd'}}</span>
                <input type="text" name="start-date" *ngIf="item.editMode==true" class="form-control select-input"
                [(ngModel)]="ctrlData.permit.date_11" placeholder="YYYY/MM/DD" required="" /></td>
              <td style="width: 15%;">
                <span *ngIf="item.editMode==false">{{item.vehicle_type}}</span>
                  <select *ngIf="item.editMode==true" class="form-control select-auto"  id="vehicle_type" [(ngModel)]="item.vehicle_type_id" [ngStyle]="{'border-color': haserror && 'red'}" (change)="onVehicleTypeSelected(i)" title="Vehichle type">
                    <option value="-1">Select Vehicle</option>
                    <option *ngFor="let type of list_vehicle_type" [ngValue]="type.id"  >{{type.description}}</option>
                  </select>
              </td>
              <!-- <td style="width: 15%;">
                <span *ngIf="item.editMode==false">{{item.vehicle_make}} </span>
                <select *ngIf="item.editMode==true" class="form-control select-auto"  id="vehicle_make" [(ngModel)]="item.vehicle_make_id" [ngStyle]="{'border-color': haserror && 'red'}" (change)="onVehicleMakeSelected(i)" title="Vehichle make">
                  <option value="-1">Select Vehicle Make</option>
                  <option *ngFor="let make of list_vehicle_make" [ngValue]="make.id">{{make.description}}</option>
                </select>
              </td> -->
              <td class="v-grid-longtext" style="width: 15%;">
                <span *ngIf="item.editMode==false">{{item.registration_number}}</span>
                <input type="text" name="registrationNumber" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.registration_number" placeholder="Registration No" required="haserror" />
              </td>
              <td style="width: 10%;">
                <span *ngIf="item.editMode==false">{{item.seating_capacity}}</span>
                <input type="text" name="seatingCapacity" *ngIf="item.editMode==true" class="form-control select-input" 
                  [(ngModel)]="item.seating_capacity" placeholder="Seats" required="" />
              </td>
              <!-- <td style="width: 15%;">
                <span *ngIf="item.editMode==false">{{item.number_passengers}}</span>
                <input type="text" name="Passengers" *ngIf="item.editMode==true" class="form-control select-input" 
                  [(ngModel)]="item.number_passengers" placeholder="Passengers" required="" />
              </td> -->
              <td style="width: 10%;">
                <span *ngIf="item.editMode==false">{{item.gvn}}</span>
                <input type="text" name="GVM" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.gvn" placeholder="GVM" required="" />
              </td>
              <td style="width: 10%;">
                <span title="{{item.vin}}" *ngIf="item.editMode==false">{{item.vin}}</span>
                <input type="text" name="VIN" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.vin" placeholder="VIN" required="" />
              </td>
              <td>
                <span title="{{item.date_license_expiry}}" *ngIf="item.editMode==false">{{item.date_license_expiry}}</span>
                <input type="text" name="date_license_expiry" *ngIf="item.editMode==true" class="form-control select-input"
                  [(ngModel)]="item.date_license_expiry" placeholder="VIN" required="" />
              </td>
              <td>
                <span *ngIf="item.editMode==false">{{ctrlData.permit.date_valid_from | date:'yyyy/MM/dd'}}</span>
                <input type="text" name="from-date" *ngIf="item.editMode==true" class="form-control select-input"
                [(ngModel)]="ctrlData.permit.date_valid_from" placeholder="YYYY/MM/DD" required="" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="col-12">
        <button class="btn btn-md m-clr pull-right hd-btn" (click)="cancelApplication()" title="Cancel"  style="float: right !important;"><i class="fa fa-times"></i> Cancel</button>
        <button title="Save & Continueto step 3" type="submit" id="btnSave" (click)=" saveVehicles()" class="btn btn-md m-clr pull-right hd-btn" style="width:auto; margin-right:10px;margin-bottom:5px;  "><i class="fa fa-save"></i> Save & Continue</button>
      </div> -->
      </div>       
    </div>
</div>
<ngx-loading [show]="pageload"></ngx-loading>

  

